<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page with improved UX
========================================================================================== -->
<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-3/4 md:w-3/5 lg:w-2/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col w-full mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8 text-center">
                  <h4 class="mb-4">비밀번호 변경</h4>
                  <p>이메일로 전송받은 코드와 변경하실 비밀번호를 입력하세요.</p>
                </div>

                <form @submit.prevent="handleResetPassword" class="my-8" autocomplete="off">
                  <div class="mb-6">
                    <ml-input
                      type="text"
                      placeholder="비밀번호 재설정 코드"
                      v-model="code"
                      class="w-full mb-1"
                      :class="{'error-input': showError && errors.code}"
                      :readonly="!!urlCode"
                      @input="validateCode"
                    />
                    <p v-if="showError && errors.code" class="text-danger text-sm">{{ errors.code }}</p>
                  </div>

                  <div class="mb-6">
                    <ml-input
                      type="password"
                      autocomplete="new-password"
                      placeholder="새 비밀번호"
                      v-model="password"
                      class="w-full mb-1"
                      :class="{'error-input': showError && errors.password}"
                      @input="validatePassword"
                      @keyup.enter="handleResetPassword"
                    />
                    <p v-if="showError && errors.password" class="text-danger text-sm">{{ errors.password }}</p>
                  </div>

                  <div class="mb-6">
                    <ml-input
                      type="password"
                      autocomplete="new-password"
                      placeholder="새 비밀번호 확인"
                      v-model="repassword"
                      class="w-full mb-1"
                      :class="{'error-input': showError && errors.repassword}"
                      @input="validateRepassword"
                      @keyup.enter="handleResetPassword"
                    />
                    <p v-if="showError && errors.repassword" class="text-danger text-sm">{{ errors.repassword }}</p>
                  </div>

<!--                  <div class="mt-6">-->
<!--                    <p class="text-sm mb-4">비밀번호는 다음 조건을 만족해야 합니다:</p>-->
<!--                    <ul class="text-sm mb-6 pl-4" style="list-style-type: disc;">-->
<!--                      <li :class="{'text-success': passwordRules.number}">숫자 포함</li>-->
<!--                      <li :class="{'text-success': passwordRules.english}">영문자 포함</li>-->
<!--                      <li :class="{'text-success': passwordRules.special}">특수문자 포함</li>-->
<!--                    </ul>-->
<!--                  </div>-->

                  <div class="flex flex-col md:flex-row justify-between space-y-4 md:space-y-0">
                    <vs-button
                      type="border"
                      to="/login"
                      class="px-4 w-full md:w-auto"
                    >
                      로그인으로 돌아가기
                    </vs-button>
                    <vs-button
                      class="px-4 w-full md:w-auto"
                      :disabled="isLoading"
                      @click="handleResetPassword"
                    >
                      {{ isLoading ? '처리중...' : '비밀번호 변경하기' }}
                    </vs-button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import constant from '@/constant/constant'

export default {
  data() {
    return {
      code: '',
      password: '',
      repassword: '',
      errors: {
        code: '',
        password: '',
        repassword: ''
      },
      isLoading: false,
      showError: false,
      // passwordRules: {
      //   number: false,
      //   english: false,
      //   special: false
      // }
    }
  },

  computed: {
    urlCode() {
      return this.$route.query.c || ''
    },

    isValidForm() {
      return !this.errors.code &&
        !this.errors.password &&
        !this.errors.repassword
        // this.passwordRules.number &&
        // this.passwordRules.english &&
        // this.passwordRules.special
    }
  },

  mounted() {
    if (this.urlCode) {
      this.code = this.urlCode
      this.validateCode()
    }
  },

  methods: {
    validateCode() {
      if (!this.code) {
        this.errors.code = '재설정 코드를 입력해주세요.'
      } else if (this.code.length < 6) {
        this.errors.code = '올바른 재설정 코드를 입력해주세요.'
      } else {
        this.errors.code = ''
      }
    },

    validatePassword() {
      // const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[!@#$%^&*])[a-z0-9!@#$%^&*]{8,16}$/i;
      const regex = /^\S{8,16}$/;

      // 각각의 규칙 검사
      // this.passwordRules.number = /[0-9]/.test(this.password)
      // this.passwordRules.english = /[a-z]/i.test(this.password)
      // this.passwordRules.special = /[!@#$%^&*]/.test(this.password)

      if (!this.password) {
        this.errors.password = '비밀번호를 입력해주세요.'
      } else if (!regex.test(this.password)) {
        this.errors.password = '비밀번호는 공백을 제외한 8~16자를 입력해주세요'
      } else {
        this.errors.password = ''
      }

      // 비밀번호 확인 재검증
      if (this.repassword) {
        this.validateRepassword()
      }
    },

    validateRepassword() {
      if (!this.repassword) {
        this.errors.repassword = '비밀번호 확인을 입력해주세요.'
      } else if (this.password !== this.repassword) {
        this.errors.repassword = '비밀번호가 일치하지 않습니다.'
      } else {
        this.errors.repassword = ''
      }
    },

    async handleResetPassword() {
      this.showError = true
      this.validateCode()
      this.validatePassword()
      this.validateRepassword()

      if (!this.isValidForm || this.isLoading) return

      try {
        this.isLoading = true
        await this.$store.dispatch('USER_RESET_PASSWORD', {
          code: this.code,
          password: this.password,
          repassword: this.repassword
        })

        this.$vs.notify({
          title: '성공',
          text: '비밀번호가 성공적으로 변경되었습니다.',
          color: 'success'
        })

        this.$router.push('/login')
      } catch (err) {
        const errorCode = constant.getErrorCode(err)
        let errorMessage = '비밀번호 변경에 실패했습니다.'

        switch (errorCode) {
        case constant.ERROR_LOGIN_PASSWORD_NULL:
          errorMessage = '비밀번호를 입력해주세요.'
          break
        case constant.ERROR_LOGIN_INVALID_RESET_CODE:
          errorMessage = '올바르지 않은 재설정 코드입니다.'
          break
        }

        this.$vs.notify({
          title: '오류',
          text: errorMessage,
          color: 'danger'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.error-input {
  border-color: var(--vs-danger) !important;
}
</style>
